<template>
  <div class="content">
    <div class="title-img">
      <img src="../assets/logo.png" alt="CNHO Logo" class="logo" />
      <div class="diver"></div>
      <h1 class="title">EXPLORER</h1>
    </div>
    <div class="search-box">
      <el-input
        placeholder="Search accounts, transactions"
        v-model="account"
        class="input-box"
        @keyup.enter.native="claimToken"
      />
      <div
        class="claim-button"
        :class="{ 'claim-button-active': account }"
        @click="claimToken"
        
      >
      <img src="../assets/icon_search_28@2x.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
export default {
  data() {
    return {
      account: "",
    };
  },
  methods: {
    getAccounts() {
      this.$api.getAccounts(this.account).then((response) => {
        let id=this.account
        this.$router.push({ name: 'Account' , params: { id }});
      }).catch((error)=>{
        if(error)this.txsHash(this.account)
      });
    },
    txsHash(id) {
      let params = {
        hash: id,
      };
      this.$api.txsHash(params).then((response) => {
        let id=this.account
        this.$router.push({ name: 'Transaction' , params: { id }});
      }).catch((error)=>{
        this.$router.push({ name: 'Nothing' ,params:{id}});
      });
    },

    claimToken() {
      if (!this.account) return;
      // let id=this.account
      this.getAccounts()
      // if(this.getAccounts()){
      //   this.$router.push({ name: 'Account' , params: { id }});
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-dialog{
  .dialog-logo{
    width: 96px;
  }
  .dialog-title{
    margin-top: 68px;
    font-size: 28px;
    font-weight: bold;
  }
  .dialog-message{
    margin-top: 24px;
    text-align: left;
    color: #000;
    .title{
      font-size: 15px;
      margin-bottom: 4px;
    }
    .account-number{
      font-size: 17px;
      padding: 10px 12px;
      background: rgba(56, 180, 139, .06);
      border-radius: 6px;
      opacity: .6;
    }
  }
  .dialog-button{
    background-color: #028760;
    font-size: 17px;
    padding: 10px;
    border-radius: 6px;
    margin-top: 100px;
    color: #fff;
    cursor: pointer;
  }
}


.dialog-title{
  text-align: left;
  color:#000
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f8f8;

  .title-img {
    display: flex;
    align-items: center;
    margin-bottom: 64px;
    margin-top: -8%;
    .diver {
      height: 24px;
      border: 2px solid #000;
      margin: 0 24px;
    }
  }
  .search-box {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 8px;
    padding: 4px;
    width: 720px;
  }
}

.logo {
  width: 210px;
}

.title {
  font-size: 40px;
  font-weight: bold;
  color: #000;
}

.input-box {
  width: 600px;
  margin-right: 20px;
}

.claim-button {
  background-color: #cbe6de;
  color: #fff;
  border-radius: 5px;
  width: 132px;
  height: 44px;
  line-height: 44px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    width: 28px;
  }
}
.claim-button-active {
  background-color: #018761 !important;
}
</style>
<style>
.input-box .el-input__inner {
  border: none;
  box-shadow: none;
}

.input-box .el-input__inner:focus {
  border: none;
  box-shadow: none;
}
.search-dialog .el-dialog__body{
  padding: 100px 80px 110px;
}
.search-dialog.el-dialog{
  border-radius: 28px;
  width: 600px!important;
}
</style>
